import { gql } from 'apollo-boost';

export const GET_CREDITS = gql`
    query GetCredits {
        getCredits
    }
`;
